import styled from 'styled-components';

import { PageContent as PageContentBase } from 'src/components/page';

export const ArticleComponent = styled.article``;

export const PageContent = styled(PageContentBase)`
  @media screen and (min-width: 2056px) {
    margin-left: 0;
  }
  margin-bottom: 0;
`;
